module.exports = __webpack_public_path__ + "img/blog_details.51f13104.png";